var map = {
	"./X33-Mall_small.jpg": 904,
	"./all-active.svg": 905,
	"./all.svg": 906,
	"./apple-watch.png": 907,
	"./b-headphone.png": 908,
	"./coin.svg": 909,
	"./delete-btn.svg": 910,
	"./iphone-13.webp": 2302,
	"./iphone-pink.png": 911,
	"./love-active.svg": 912,
	"./love.svg": 913,
	"./mobile-bg.jpg": 914,
	"./mobile-bg.webp": 2303,
	"./price-high-active.svg": 915,
	"./price-high.svg": 916,
	"./price-low-active.svg": 917,
	"./price-low.svg": 918,
	"./rewards-dnp-cn.webp": 2304,
	"./rewards-dnp.webp": 2305,
	"./shopping-cart.svg": 919,
	"./star.svg": 920,
	"./x33mall-banner-cn.jpg": 921,
	"./x33mall-banner-cn.webp": 2306,
	"./x33mall-banner-id.jpg": 922,
	"./x33mall-banner-ms.jpg": 923,
	"./x33mall-banner-ms.webp": 2307,
	"./x33mall-banner.jpg": 924,
	"./x33mall-banner.webp": 2308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 926;